import { emailPattern } from '../appconfig/Settings';

// Login validate
export const LoginValidate = (inputDetail: any) => {
    let isError: boolean = false;

    let errorObj: any = {};

    let errors: any = {};

    if (window.cn(inputDetail.mobile) && !window.cb(inputDetail.mobile)) {
        errors = { ...errors, mobile: 'Enter Email *' };
        isError = true;
    } else if (inputDetail.mobile !== undefined) {
        if (inputDetail.mobile.length > 10 || inputDetail.mobile.length < 10) {
            errors = { ...errors, mobile: 'Mobile Number must be 10 digits. *' };
            isError = true;
        }
    } else {
        errors = { ...errors, mobile: '' };
    }

    errorObj = { errors, isError };

    return errorObj;
};

// Chnage Password validate
export const ChangePasswordValidate = (inputDetail: any) => {
    let isError: boolean = false;

    let errorObj: any = {};

    let errors: any = {};

    if (window.cn(inputDetail?.current_password) && !window.cb(inputDetail?.current_password)) {
        errors = { ...errors, current_password: 'Enter Current Password *' };
        isError = true;
    } else {
        errors = { ...errors, current_password: '' };
    }

    if (window.cn(inputDetail?.new_password) && !window.cb(inputDetail?.new_password)) {
        errors = { ...errors, new_password: 'Enter New Password *' };
        isError = true;
    } else {
        errors = { ...errors, new_password: '' };
    }

    if (window.cn(inputDetail?.confirm_password) && !window.cb(inputDetail?.confirm_password)) {
        errors = { ...errors, confirm_password: 'Enter Confirm Password *' };
        isError = true;
    } else {
        errors = { ...errors, confirm_password: '' };
    }

    errorObj = { errors, isError };

    return errorObj;
};

// Login validate
export const OTPValidate = (otpNum: any) => {
    let isError: boolean = false;

    let errorObj: any = {};

    let errors: any = {};

    if (window.cn(otpNum) && !window.cb(otpNum)) {
        errors = { ...errors, otpNum: 'Enter OTP *' };
        isError = true;
    } else if (otpNum !== undefined) {
        if (otpNum.length > 4 || otpNum.length < 4) {
            errors = { ...errors, otpNum: 'OTP must be 4 digits. *' };
            isError = true;
        }
    } else {
        errors = { ...errors, otpNum: '' };
    }

    errorObj = { errors, isError };

    return errorObj;
};

// Add update college validate
export const addUpdateCollegeValidate = (collegeDetails: any, principalSign: any, editId: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(collegeDetails.email) && !window.cb(collegeDetails.email)) {
        errors = { ...errors, email: 'Please Enter Email *' };
        isError = true;
    } else if (!emailPattern.test(collegeDetails.email)) {
        errors = { ...errors, email: 'Please Enter Valid Email*' };
        isError = true;
    } else {
        errors = { ...errors, email: '' };
    }

    if (window.cn(collegeDetails.college) && !window.cb(collegeDetails.college)) {
        errors = { ...errors, college: 'Please Select College *' };
        isError = true;
    } else {
        errors = { ...errors, college: '' };
    }

    if (window.cn(collegeDetails.principal_name) && !window.cb(collegeDetails.principal_name)) {
        errors = { ...errors, principal_name: 'Please Enter principal Name *' };
        isError = true;
    } else {
        errors = { ...errors, principal_name: '' };
    }

    if (window.cn(collegeDetails.mobile) && !window.cb(collegeDetails.mobile)) {
        errors = { ...errors, mobile: 'Please Enter Mobile No. *' };
        isError = true;
    } else if (collegeDetails.mobile !== undefined) {
        if (collegeDetails.mobile.length > 10) {
            errors = { ...errors, mobile: 'Please Enter Valid Mobile No. *' };
            isError = true;
        }
    } else {
        errors = { ...errors, mobile: '' };
    }

    if (editId === null) {
        if (window.cn(collegeDetails.password) && !window.cb(collegeDetails.password)) {
            errors = { ...errors, password: 'Please Enter Password *' };
            isError = true;
        } else {
            errors = { ...errors, password: '' };
        }
    }

    errorObj = { errors, isError };
    return errorObj;
};

// View application change status validate
export const viewApplicationChangeStatusValidate = (selectedAppStatus: any, reason: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(selectedAppStatus) && !window.cb(selectedAppStatus)) {
        errors = { ...errors, appStatus: 'Please Select Application Status *' };
        isError = true;
    } else {
        errors = { ...errors, appStatus: '' };
    }

    if (window.cn(reason) && !window.cb(reason)) {
        errors = { ...errors, reason: 'Please Enter Reason *' };
        isError = true;
    } else {
        errors = { ...errors, reason: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

// Application change status validate
export const applicationChangeStatusValidate = (selectedApplicationStatus: any, reason: any, unverifiedDocs: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(selectedApplicationStatus) && !window.cb(selectedApplicationStatus)) {
        errors = { ...errors, appStatus: 'Please Select Application Status *' };
        isError = true;
    } else {
        errors = { ...errors, appStatus: '' };
    }

    if (selectedApplicationStatus?.name === 'Document Not Proper') {
        errors = { ...errors, reason: '' };
        if (unverifiedDocs.length === 0) {
            errors = { ...errors, unverified_docs: 'Please Select Application Status *' };
            isError = true;
        } else {
            errors = { ...errors, unverified_docs: '' };
        }
    } else {
        errors = { ...errors, unverified_docs: '' };
        if (window.cn(reason) && !window.cb(reason)) {
            errors = { ...errors, reason: 'Please Select Reason *' };
            isError = true;
        } else {
            errors = { ...errors, reason: '' };
        }
    }

    errorObj = { errors, isError };
    return errorObj;
};

// Election Deposit Reject Validate
export const electionDepositRejectValidate = (rejectReason: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(rejectReason) && !window.cb(rejectReason)) {
        errors = { ...errors, reason: 'Please Enter Reason *' };
        isError = true;
    } else {
        errors = { ...errors, reason: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

// Registration Cancellation Validate
export const regCancelValidate = (regCancelData: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(regCancelData?.RegNo) && !window.cb(regCancelData?.RegNo)) {
        errors = { ...errors, RegNo: 'Please Enter Reg No. *' };
        isError = true;
    } else {
        errors = { ...errors, RegNo: '' };
    }

    if (window.cn(regCancelData?.Reason) && !window.cb(regCancelData?.Reason)) {
        errors = { ...errors, reason: 'Please Enter Reason *' };
        isError = true;
    } else {
        errors = { ...errors, reason: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

// User Management Validate
export const addUpdateUserValidate = (userDetails: any, editId: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(userDetails?.first_name) && !window.cb(userDetails?.first_name)) {
        errors = { ...errors, first_name: 'Please Enter First Name *' };
        isError = true;
    } else {
        errors = { ...errors, first_name: '' };
    }

    if (window.cn(userDetails?.sur_name) && !window.cb(userDetails?.sur_name)) {
        errors = { ...errors, sur_name: 'Please Enter Surname *' };
        isError = true;
    } else {
        errors = { ...errors, sur_name: '' };
    }

    if (window.cn(userDetails?.mobile) && !window.cb(userDetails?.mobile)) {
        errors = { ...errors, mobile: 'Please Enter Mobile Number *' };
        isError = true;
    } else if (userDetails.mobile !== undefined) {
        if (userDetails.mobile.length > 10) {
            errors = { ...errors, mobile: 'Please Enter Valid Mobile No. *' };
            isError = true;
        }
    } else {
        errors = { ...errors, mobile: '' };
    }

    if (window.cn(userDetails?.role) && !window.cb(userDetails?.role)) {
        errors = { ...errors, role: 'Please Select Role *' };
        isError = true;
    } else {
        errors = { ...errors, role: '' };
    }

    if (editId === null) {
        if (window.cn(userDetails?.email) && !window.cb(userDetails?.email)) {
            errors = { ...errors, email: 'Please Enter Email *' };
            isError = true;
        } else {
            errors = { ...errors, email: '' };
        }

        if (window.cn(userDetails?.password) && !window.cb(userDetails?.password)) {
            errors = { ...errors, password: 'Please Enter Password *' };
            isError = true;
        } else {
            errors = { ...errors, password: '' };
        }

        if (window.cn(userDetails?.confirm_password) && !window.cb(userDetails?.confirm_password)) {
            errors = { ...errors, confirm_password: 'Please Enter Confirm Password *' };
            isError = true;
        } else if (userDetails?.confirm_password !== userDetails?.password) {
            errors = { ...errors, confirm_password: 'Password and confirm password does not match *' };
            isError = true;
        } else {
            errors = { ...errors, confirm_password: '' };
        }
    }

    errorObj = { errors, isError };
    return errorObj;
};

// Add Appointment Booking Validate
export const addAppointmentBookingValidate = (appointmentData: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(appointmentData?.bookingDate) && !window.cb(appointmentData?.bookingDate)) {
        errors = { ...errors, bookingDate: 'Please Select Date. *' };
        isError = true;
    } else {
        errors = { ...errors, bookingDate: '' };
    }

    if (window.cn(appointmentData?.application_type) && !window.cb(appointmentData?.application_type)) {
        errors = { ...errors, application_type: 'Please Select Application type *' };
        isError = true;
    } else {
        errors = { ...errors, application_type: '' };
    }

    if (window.cn(appointmentData?.ava_slots) && !window.cb(appointmentData?.ava_slots)) {
        errors = { ...errors, ava_slots: 'Please Enter Total Slots *' };
        isError = true;
    } else {
        errors = { ...errors, ava_slots: '' };
    }

    if (window.cn(appointmentData?.slot_start_time) && !window.cb(appointmentData?.slot_start_time)) {
        errors = { ...errors, slot_start_time: 'Please Select Slot Start Time *' };
        isError = true;
    } else {
        errors = { ...errors, slot_start_time: '' };
    }

    if (window.cn(appointmentData?.slot_end_time) && !window.cb(appointmentData?.slot_end_time)) {
        errors = { ...errors, slot_end_time: 'Please Select Slot End Time *' };
        isError = true;
    } else {
        errors = { ...errors, slot_end_time: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

// List Bank Entry Validate
export const ListBankEntryValidate = (bank: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(bank) && !window.cb(bank)) {
        errors = { ...errors, bank: 'Please Select Bank *' };
        isError = true;
    } else {
        errors = { ...errors, bank: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

// Add Bank Entry Validate
export const AddBankEntryValidate = (bankEntryData: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(bankEntryData.bankSelect) && !window.cb(bankEntryData.bankSelect)) {
        errors = { ...errors, bankSelect: 'Please Select Bank *' };
        isError = true;
    } else {
        errors = { ...errors, bankSelect: '' };
    }

    if (window.cn(bankEntryData.accName) && !window.cb(bankEntryData.accName)) {
        errors = { ...errors, accName: 'Please Select Account *' };
        isError = true;
    } else {
        errors = { ...errors, accName: '' };
    }

    if (window.cn(bankEntryData.cheqNo) && !window.cb(bankEntryData.cheqNo)) {
        errors = { ...errors, cheqNo: 'Please Enter Cheque No. *' };
        isError = true;
    } else {
        errors = { ...errors, cheqNo: '' };
    }

    if (window.cn(bankEntryData.dw) && !window.cb(bankEntryData.dw)) {
        errors = { ...errors, dw: 'Please Select D/W *' };
        isError = true;
    } else {
        errors = { ...errors, dw: '' };
    }

    if (window.cn(bankEntryData.amount) && !window.cb(bankEntryData.amount)) {
        errors = { ...errors, amount: 'Please Enter Amount *' };
        isError = true;
    } else {
        errors = { ...errors, amount: '' };
    }

    if (window.cn(bankEntryData.remark) && !window.cb(bankEntryData.remark)) {
        errors = { ...errors, remark: 'Please Enter Remark *' };
        isError = true;
    } else {
        errors = { ...errors, remark: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

// Add Cash Entry Validate
export const AddCashEntryValidate = (cashEntryData: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(cashEntryData.accName) && !window.cb(cashEntryData.accName)) {
        errors = { ...errors, accName: 'Please Select Account *' };
        isError = true;
    } else {
        errors = { ...errors, accName: '' };
    }

    if (window.cn(cashEntryData.pr) && !window.cb(cashEntryData.pr)) {
        errors = { ...errors, pr: 'Please Select P/R *' };
        isError = true;
    } else {
        errors = { ...errors, pr: '' };
    }

    if (window.cn(cashEntryData.amount) && !window.cb(cashEntryData.amount)) {
        errors = { ...errors, amount: 'Please Enter Amount *' };
        isError = true;
    } else {
        errors = { ...errors, amount: '' };
    }

    if (window.cn(cashEntryData.remark) && !window.cb(cashEntryData.remark)) {
        errors = { ...errors, remark: 'Please Enter Remark *' };
        isError = true;
    } else {
        errors = { ...errors, remark: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

// List JV Entry Validate
export const ListJVEntryValidate = (year: any, voucher: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(year) && !window.cb(year)) {
        errors = { ...errors, year: 'Please Select Year *' };
        isError = true;
    } else {
        errors = { ...errors, year: '' };
    }

    if (window.cn(voucher) && !window.cb(voucher)) {
        errors = { ...errors, voucher: 'Please Select Voucher *' };
        isError = true;
    } else {
        errors = { ...errors, voucher: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

// Add JV Entry Validate
export const AddJVEntryValidate = (cashEntryData: any, type: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(cashEntryData.accName) && !window.cb(cashEntryData.accName)) {
        errors = { ...errors, accName: 'Please Select Account *' };
        isError = true;
    } else {
        errors = { ...errors, accName: '' };
    }

    if (window.cn(type) && !window.cb(type)) {
        errors = { ...errors, type: 'Please Select Type *' };
        isError = true;
    } else {
        errors = { ...errors, type: '' };
    }

    if (!window.cn(type) && type?.code === 'credit') {
        if (window.cn(cashEntryData.credit) && !window.cb(cashEntryData.credit)) {
            errors = { ...errors, credit: 'Please Enter Credit Amount*' };
            isError = true;
        } else {
            errors = { ...errors, credit: '' };
        }
    }

    if (!window.cn(type) && type?.code === 'debit') {
        if (window.cn(cashEntryData.debit) && !window.cb(cashEntryData.debit)) {
            errors = { ...errors, debit: 'Please Enter Debit Amount*' };
            isError = true;
        } else {
            errors = { ...errors, debit: '' };
        }
    }

    if (window.cn(cashEntryData.remark) && !window.cb(cashEntryData.remark)) {
        errors = { ...errors, remark: 'Please Enter Remark *' };
        isError = true;
    } else {
        errors = { ...errors, remark: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

// Add Update Account Master Validate
export const AddUpdateAccountMasterValidate = (accountData: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(accountData.accName) && !window.cb(accountData.accName)) {
        errors = { ...errors, accName: 'Please Enter Account Name *' };
        isError = true;
    } else {
        errors = { ...errors, accName: '' };
    }

    if (window.cn(accountData.openingbal) && !window.cb(accountData.openingbal)) {
        errors = { ...errors, openingbal: 'Please Enter Opening Balance *' };
        isError = true;
    } else {
        errors = { ...errors, openingbal: '' };
    }

    if (window.cn(accountData.accGroup) && !window.cb(accountData.accGroup)) {
        errors = { ...errors, accGroup: 'Please Select Account Group *' };
        isError = true;
    } else {
        errors = { ...errors, accGroup: '' };
    }

    if (window.cn(accountData.type) && !window.cb(accountData.type)) {
        errors = { ...errors, type: 'Please Select Type *' };
        isError = true;
    } else {
        errors = { ...errors, type: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

// Add Update Account Group Validate
export const AddUpdateAccountGroupValidate = (accountGroupData: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(accountGroupData.accGroupNm) && !window.cb(accountGroupData.accGroupNm)) {
        errors = { ...errors, accGroupNm: 'Please Enter Account Group Name *' };
        isError = true;
    } else {
        errors = { ...errors, accGroupNm: '' };
    }

    if (window.cn(accountGroupData.accSeq) && !window.cb(accountGroupData.accSeq)) {
        errors = { ...errors, accSeq: 'Please Enter Sequence *' };
        isError = true;
    } else {
        errors = { ...errors, accSeq: '' };
    }

    if (window.cn(accountGroupData.accGroup) && !window.cb(accountGroupData.accGroup)) {
        errors = { ...errors, accGroup: 'Please Select Account Group *' };
        isError = true;
    } else {
        errors = { ...errors, accGroup: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

// Certificate Show Click Validate
export const CertificateShowClick = (regNo: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(regNo) && !window.cb(regNo)) {
        errors = { ...errors, regNo: 'Please Enter Reg No. *' };
        isError = true;
    } else {
        errors = { ...errors, regNo: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

// Save Good Standing Certificate Validate
export const SaveGoodStandingCertificateValidate = (certificateData: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(certificateData.toAddress) && !window.cb(certificateData.toAddress)) {
        errors = { ...errors, toAddress: 'Please Enter To Address. *' };
        isError = true;
    } else {
        errors = { ...errors, toAddress: '' };
    }

    if (window.cn(certificateData.fdaddress) && !window.cb(certificateData.fdaddress)) {
        errors = { ...errors, fdaddress: 'Please Enter F&D Address *' };
        isError = true;
    } else {
        errors = { ...errors, fdaddress: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

// Registration Date Update Validate
export const RegistrationDateUpdateValidate = (regNo: any, date: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(regNo) && !window.cb(regNo)) {
        errors = { ...errors, regNo: 'Please Enter Reg No. *' };
        isError = true;
    } else {
        errors = { ...errors, regNo: '' };
    }

    if (window.cn(date) && !window.cb(date)) {
        errors = { ...errors, date: 'Please Select Date. *' };
        isError = true;
    } else {
        errors = { ...errors, date: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

// Add Update Department Validate
export const AddUpdateDepartmentValidate = (name: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(name) && !window.cb(name)) {
        errors = { ...errors, name: 'Please Enter Department Name *' };
        isError = true;
    } else {
        errors = { ...errors, name: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

// Add Update  Online Refresher Course Validate
export const AddUpdateOnlineRefresherCourseValidate = (courseDetails: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(courseDetails.refresher_course_name) && !window.cb(courseDetails.refresher_course_name)) {
        errors = { ...errors, refresher_course_name: 'Please Enter Refresher Course Name *' };
        isError = true;
    } else {
        errors = { ...errors, refresher_course_name: '' };
    }

    if (window.cn(courseDetails.college_id) && !window.cb(courseDetails.college_id)) {
        errors = { ...errors, college_id: 'Please Select College *' };
        isError = true;
    } else {
        errors = { ...errors, college_id: '' };
    }

    if (window.cn(courseDetails.total_slot) && !window.cb(courseDetails.total_slot)) {
        errors = { ...errors, total_slot: 'Please Select Total Slots *' };
        isError = true;
    } else {
        errors = { ...errors, total_slot: '' };
    }

    if (window.cn(courseDetails.start_date) && !window.cb(courseDetails.start_date)) {
        errors = { ...errors, start_date: 'Please Select Start Date *' };
        isError = true;
    } else {
        errors = { ...errors, start_date: '' };
    }

    if (window.cn(courseDetails.end_date) && !window.cb(courseDetails.end_date)) {
        errors = { ...errors, end_date: 'Please Select End Date *' };
        isError = true;
    } else {
        errors = { ...errors, end_date: '' };
    }

    if (window.cn(courseDetails.contact_person_1_name) && !window.cb(courseDetails.contact_person_1_name)) {
        errors = { ...errors, contact_person_1_name: 'Please Enter Name *' };
        isError = true;
    } else {
        errors = { ...errors, contact_person_1_name: '' };
    }

    if (window.cn(courseDetails.contact_person_1_email) && !window.cb(courseDetails.contact_person_1_email)) {
        errors = { ...errors, contact_person_1_email: 'Please Enter Email *' };
        isError = true;
    } else {
        errors = { ...errors, contact_person_1_email: '' };
    }

    if (window.cn(courseDetails.contact_person_1_mobile) && !window.cb(courseDetails.contact_person_1_mobile)) {
        errors = { ...errors, contact_person_1_mobile: 'Please Enter Mobile No. *' };
        isError = true;
    } else if (courseDetails.contact_person_1_mobile.length < 10 || courseDetails.contact_person_1_mobile.length > 10) {
        errors = {
            ...errors,
            contact_person_1_mobile: 'Mobile Number Length should be 10 digits *'
        };
        isError = true;
    } else {
        errors = { ...errors, contact_person_1_mobile: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

// Add Update  Offline Refresher Course Validate
export const AddUpdateOfflineRefresherCourseValidate = (courseDetails: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(courseDetails.refresher_course_name) && !window.cb(courseDetails.refresher_course_name)) {
        errors = { ...errors, refresher_course_name: 'Please Enter Refresher Course Name *' };
        isError = true;
    } else {
        errors = { ...errors, refresher_course_name: '' };
    }

    if (window.cn(courseDetails.college_id) && !window.cb(courseDetails.college_id)) {
        errors = { ...errors, college_id: 'Please Select College *' };
        isError = true;
    } else {
        errors = { ...errors, college_id: '' };
    }

    if (window.cn(courseDetails.total_slot) && !window.cb(courseDetails.total_slot)) {
        errors = { ...errors, total_slot: 'Please Select Total Slots *' };
        isError = true;
    } else {
        errors = { ...errors, total_slot: '' };
    }

    if (window.cn(courseDetails.start_date) && !window.cb(courseDetails.start_date)) {
        errors = { ...errors, start_date: 'Please Select Start Date *' };
        isError = true;
    } else {
        errors = { ...errors, start_date: '' };
    }

    if (window.cn(courseDetails.end_date) && !window.cb(courseDetails.end_date)) {
        errors = { ...errors, end_date: 'Please Select End Date *' };
        isError = true;
    } else {
        errors = { ...errors, end_date: '' };
    }

    if (window.cn(courseDetails.contact_person_1_name) && !window.cb(courseDetails.contact_person_1_name)) {
        errors = { ...errors, contact_person_1_name: 'Please Enter Name *' };
        isError = true;
    } else {
        errors = { ...errors, contact_person_1_name: '' };
    }

    if (window.cn(courseDetails.contact_person_1_email) && !window.cb(courseDetails.contact_person_1_email)) {
        errors = { ...errors, contact_person_1_email: 'Please Enter Email *' };
        isError = true;
    } else {
        errors = { ...errors, contact_person_1_email: '' };
    }

    if (window.cn(courseDetails.contact_person_1_mobile) && !window.cb(courseDetails.contact_person_1_mobile)) {
        errors = { ...errors, contact_person_1_mobile: 'Please Enter Mobile No. *' };
        isError = true;
    } else if (courseDetails.contact_person_1_mobile.length < 10 || courseDetails.contact_person_1_mobile.length > 10) {
        errors = {
            ...errors,
            contact_person_1_mobile: 'Mobile Number Length should be 10 digits *'
        };
        isError = true;
    } else {
        errors = { ...errors, contact_person_1_mobile: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

// Add Application Bill Master Validate
export const AddAppBillMasterValidate = (appBillMasterData: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(appBillMasterData.applicationName) && !window.cb(appBillMasterData.applicationName)) {
        errors = { ...errors, applicationName: 'Please Select Application *' };
        isError = true;
    } else {
        errors = { ...errors, applicationName: '' };
    }

    if (window.cn(appBillMasterData.itemName) && !window.cb(appBillMasterData.itemName)) {
        errors = { ...errors, itemName: 'Please Select Bill Item *' };
        isError = true;
    } else {
        errors = { ...errors, itemName: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

// Add Update Application Validate
export const AddUpdateApplicationValidate = (name: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(name) && !window.cb(name)) {
        errors = { ...errors, name: 'Please Enter Application Name *' };
        isError = true;
    } else {
        errors = { ...errors, name: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

// Add Update Application Document Validate
export const AddUpdateAppDocValidate = (name: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(name) && !window.cb(name)) {
        errors = { ...errors, name: 'Please Enter Application Name *' };
        isError = true;
    } else {
        errors = { ...errors, name: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

//inward refiser  add validate
export const InwardRegistar = (inWardData: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(inWardData?.FromNm) && !window.cb(inWardData?.FromNm)) {
        errors = { ...errors, FromNm: 'Please Enter Form Name *' };
        isError = true;
    } else {
        errors = { ...errors, FromNm: '' };
    }

    if (window.cn(inWardData?.Sub) && !window.cb(inWardData?.Sub)) {
        errors = { ...errors, Sub: 'Please Enter Subject *' };
        isError = true;
    } else {
        errors = { ...errors, Sub: '' };
    }

    if (window.cn(inWardData?.TypeNo?.code) && !window.cb(inWardData?.TypeNo?.code)) {
        errors = { ...errors, TypeNo: 'Please Select Type *' };
        isError = true;
    } else {
        errors = { ...errors, TypeNo: '' };
    }

    if (window.cn(inWardData?.IOType?.code) && !window.cb(inWardData?.IOType?.code)) {
        errors = { ...errors, IOType: 'Please Select Sub Type *' };
        isError = true;
    } else {
        errors = { ...errors, IOType: '' };
    }

    if (window.cn(inWardData?.Note1) && !window.cb(inWardData?.Note1)) {
        errors = { ...errors, Note1: 'Please Enter Note *' };
        isError = true;
    } else {
        errors = { ...errors, Note1: '' };
    }

    if (window.cn(inWardData?.ToAddress) && !window.cb(inWardData?.ToAddress)) {
        errors = { ...errors, ToAddress: 'Please Enter Address *' };
        isError = true;
    } else {
        errors = { ...errors, ToAddress: '' };
    }

    if (window.cn(inWardData?.EntDt) && !window.cb(inWardData?.EntDt)) {
        errors = { ...errors, EntDt: 'Please Enter Date *' };
        isError = true;
    } else {
        errors = { ...errors, EntDt: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

//outward register  add validate
export const OutwardRegistar = (outWardData: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(outWardData?.ToNm) && !window.cb(outWardData?.ToNm)) {
        errors = { ...errors, ToNm: 'Please Enter To Name *' };
        isError = true;
    } else {
        errors = { ...errors, ToNm: '' };
    }

    if (window.cn(outWardData?.Sub) && !window.cb(outWardData?.Sub)) {
        errors = { ...errors, Sub: 'Please Enter Subject *' };
        isError = true;
    } else {
        errors = { ...errors, Sub: '' };
    }

    if (window.cn(outWardData?.TypeNo?.code) && !window.cb(outWardData?.TypeNo?.code)) {
        errors = { ...errors, TypeNo: 'Please Select Type *' };
        isError = true;
    } else {
        errors = { ...errors, TypeNo: '' };
    }

    if (window.cn(outWardData?.IOType?.code) && !window.cb(outWardData?.IOType?.code)) {
        errors = { ...errors, IOType: 'Please Select Sub Type *' };
        isError = true;
    } else {
        errors = { ...errors, IOType: '' };
    }

    if (window.cn(outWardData?.Note1) && !window.cb(outWardData?.Note1)) {
        errors = { ...errors, Note1: 'Please Enter Note *' };
        isError = true;
    } else {
        errors = { ...errors, Note1: '' };
    }

    if (window.cn(outWardData?.Amt) && !window.cb(outWardData?.Amt)) {
        errors = { ...errors, Amt: 'Please Enter Amount *' };
        isError = true;
    } else {
        errors = { ...errors, Amt: '' };
    }

    if (window.cn(outWardData?.ToAddress) && !window.cb(outWardData?.ToAddress)) {
        errors = { ...errors, ToAddress: 'Please Enter Address *' };
        isError = true;
    } else {
        errors = { ...errors, ToAddress: '' };
    }

    if (window.cn(outWardData?.EntDt) && !window.cb(outWardData?.EntDt)) {
        errors = { ...errors, EntDt: 'Please Enter Date *' };
        isError = true;
    } else {
        errors = { ...errors, EntDt: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

// Add Update Application Validate
export const AddUpdateBillMasterValidate = (name: any, state: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(name) && !window.cb(name)) {
        errors = { ...errors, name: 'Please Enter Board Name *' };
        isError = true;
    } else {
        errors = { ...errors, name: '' };
    }

    if (window.cn(state?.code) && !window.cb(state?.code)) {
        errors = { ...errors, state: 'Please Select State *' };
        isError = true;
    } else {
        errors = { ...errors, state: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

// Add Approval Master Validate
export const AddApprovalMasterValidate = (approvalData: any, isDegreeMfarm: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(approvalData?.StateNm?.code) && !window.cb(approvalData?.StateNm?.code)) {
        errors = { ...errors, StateNm: 'Please Select State *' };
        isError = true;
    } else {
        errors = { ...errors, StateNm: '' };
    }

    if (window.cn(approvalData?.college?.code) && !window.cb(approvalData?.college?.code)) {
        errors = { ...errors, college: 'Please Select College *' };
        isError = true;
    } else {
        errors = { ...errors, college: '' };
    }

    if (window.cn(approvalData?.university?.code) && !window.cb(approvalData?.university?.code)) {
        errors = { ...errors, university: 'Please Select University *' };
        isError = true;
    } else {
        errors = { ...errors, university: '' };
    }

    if (window.cn(approvalData?.degree?.code) && !window.cb(approvalData?.degree?.code)) {
        errors = { ...errors, degree: 'Please Select Degree *' };
        isError = true;
    } else {
        errors = { ...errors, degree: '' };
    }

    if (approvalData?.degree?.name === 'M Pharm' && window.cn(approvalData?.subject)) {
        errors = { ...errors, subject: 'Please Enter Subject *' };
        isError = true;
    } else {
        errors = { ...errors, subject: '' };
    }

    if (window.cn(approvalData.pciResNo) && !window.cb(approvalData.pciResNo)) {
        errors = { ...errors, pciResNo: 'Please Enter PCI Res No *' };
        isError = true;
    } else {
        errors = { ...errors, pciResNo: '' };
    }

    if (window.cn(approvalData.pciRefNo) && !window.cb(approvalData.pciRefNo)) {
        errors = { ...errors, pciRefNo: 'Please Enter PCI Ref No *' };
        isError = true;
    } else {
        errors = { ...errors, pciRefNo: '' };
    }

    if (window.cn(approvalData.seatsTotal) && !window.cb(approvalData.seatsTotal)) {
        errors = { ...errors, seatsTotal: 'Please Enter Seats *' };
        isError = true;
    } else {
        errors = { ...errors, seatsTotal: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

// Add Approval Master Validate
export const PendingApprovalMasterValidate = (approvalData: any, selectedRow: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(approvalData?.university?.code) && !window.cb(approvalData?.university?.code)) {
        errors = { ...errors, university: 'Please Select University *' };
        isError = true;
    } else {
        errors = { ...errors, university: '' };
    }

    if (window.cn(approvalData.pciResNo) && !window.cb(approvalData.pciResNo)) {
        errors = { ...errors, pciResNo: 'Please Enter PCI Res No *' };
        isError = true;
    } else {
        errors = { ...errors, pciResNo: '' };
    }

    if (window.cn(selectedRow?.pci_code) && !window.cb(selectedRow?.pci_code)) {
        errors = { ...errors, pciRefNo: 'Please Enter PCI Code *' };
        isError = true;
    } else {
        errors = { ...errors, pciRefNo: '' };
    }

    if (selectedRow?.degree_name === 'M Pharm' && window.cn(approvalData?.subject)) {
        errors = { ...errors, subject: 'Please Enter Subject *' };
        isError = true;
    } else {
        errors = { ...errors, subject: '' };
    }

    if (window.cn(approvalData.seatsTotal) && !window.cb(approvalData.seatsTotal)) {
        errors = { ...errors, seatsTotal: 'Please Enter Seats *' };
        isError = true;
    } else {
        errors = { ...errors, seatsTotal: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

// reason validation
export const reasonValidate = (reasonData: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(reasonData.status)) {
        errors.status = 'Status is required *';
        isError = true;
    }

    if (reasonData.status === 'Reupload' && window.cn(reasonData.reason)) {
        errors.reason = 'Reason is required *';
        isError = true;
    }

    errorObj = { errors, isError };
    return errorObj;
};

// Add College entry Validate
export const AddCollegeEntryValidate = (collegeEntryData: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(collegeEntryData?.StateNm?.code) && !window.cb(collegeEntryData?.StateNm?.code)) {
        errors = { ...errors, StateNm: 'Please Select State *' };
        isError = true;
    } else {
        errors = { ...errors, StateNm: '' };
    }

    if (window.cn(collegeEntryData?.university?.code) && !window.cb(collegeEntryData?.university?.code)) {
        errors = { ...errors, university: 'Please Select University *' };
        isError = true;
    } else {
        errors = { ...errors, university: '' };
    }

    if (window.cn(collegeEntryData?.collegeName) && !window.cb(collegeEntryData?.collegeName)) {
        errors = { ...errors, collegeName: 'Please Enter College Name *' };
        isError = true;
    } else {
        errors = { ...errors, collegeName: '' };
    }

    if (window.cn(collegeEntryData?.collegeAddress) && !window.cb(collegeEntryData?.collegeAddress)) {
        errors = { ...errors, collegeAddress: 'Please Enter Address *' };
        isError = true;
    } else {
        errors = { ...errors, collegeAddress: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

// Add Council entry Validate
export const AddCouncilMasterValidate = (councilMasterData: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(councilMasterData?.StateNm?.code) && !window.cb(councilMasterData?.StateNm?.code)) {
        errors = { ...errors, StateNm: 'Please Select State *' };
        isError = true;
    } else {
        errors = { ...errors, StateNm: '' };
    }

    if (window.cn(councilMasterData?.name) && !window.cb(councilMasterData?.name)) {
        errors = { ...errors, name: 'Please Enter Council Name *' };
        isError = true;
    } else {
        errors = { ...errors, name: '' };
    }

    if (window.cn(councilMasterData?.address) && !window.cb(councilMasterData?.address)) {
        errors = { ...errors, address: 'Please Enter Address *' };
        isError = true;
    } else {
        errors = { ...errors, address: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

// Add Hospital Master Validate
export const AddHospitalMasterValidate = (hospitalData: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(hospitalData?.StateNm?.code) && !window.cb(hospitalData?.StateNm?.code)) {
        errors = { ...errors, StateNm: 'Please Select State *' };
        isError = true;
    } else {
        errors = { ...errors, StateNm: '' };
    }

    if (window.cn(hospitalData?.hospitalName) && !window.cb(hospitalData?.hospitalName)) {
        errors = { ...errors, hospitalName: 'Please Enter Hospital Name *' };
        isError = true;
    } else {
        errors = { ...errors, hospitalName: '' };
    }

    if (window.cn(hospitalData?.hospitalAddress) && !window.cb(hospitalData?.hospitalAddress)) {
        errors = { ...errors, hospitalAddress: 'Please Enter Address *' };
        isError = true;
    } else {
        errors = { ...errors, hospitalAddress: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

// Add Other Master Validate
export const AddOtherMasterValidate = (otherMasterData: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(otherMasterData?.new_entry) && !window.cb(otherMasterData?.new_entry)) {
        errors = { ...errors, new_entry: 'Enter New Entry *' };
        isError = true;
    } else {
        errors = { ...errors, new_entry: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

// Add University Master Validate
export const AddUniversityMasterValidate = (universityData: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(universityData?.UName) && !window.cb(universityData?.UName)) {
        errors = { ...errors, UName: 'Please Enter University Name *' };
        isError = true;
    } else {
        errors = { ...errors, UName: '' };
    }

    if (window.cn(universityData?.Uadd) && !window.cb(universityData?.Uadd)) {
        errors = { ...errors, Uadd: 'Please Enter Address *' };
        isError = true;
    } else {
        errors = { ...errors, Uadd: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

// Add User Update Validate
export const UserUpdateValidate = (userUpdateData: any, date: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(userUpdateData.reg_no) && !window.cb(userUpdateData.reg_no)) {
        errors = { ...errors, reg_no: 'Please Enter Reg No. *' };
        isError = true;
    } else {
        errors = { ...errors, reg_no: '' };
    }

    if (window.cn(date) && !window.cb(date)) {
        errors = { ...errors, date: 'Please Select Date *' };
        isError = true;
    } else {
        errors = { ...errors, itemName: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

// Add User Update email passwors Validate
export const UserUpdateEmailPassValidate = (userUpdateData: any, index: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (index === 1) {
        if (window.cn(userUpdateData.old_email) && !window.cb(userUpdateData.old_email)) {
            errors = { ...errors, old_email: 'Please Enter Email *' };
            isError = true;
        } else {
            errors = { ...errors, old_email: '' };
        }
        if (window.cn(userUpdateData.new_email) && !window.cb(userUpdateData.new_email)) {
            errors = { ...errors, new_email: 'Please Enter Email *' };
            isError = true;
        } else {
            errors = { ...errors, new_email: '' };
        }
    }

    if (index === 2) {
        if (window.cn(userUpdateData?.exist_email) && !window.cb(userUpdateData?.exist_email)) {
            errors = { ...errors, exist_email: 'Please Enter Email *' };
            isError = true;
        } else {
            errors = { ...errors, exist_email: '' };
        }
    }

    errorObj = { errors, isError };
    return errorObj;
};

// Add User Update photo Validate
export const UserUpdatePhotoValidate = (userUpdateData: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(userUpdateData?.update_photo_reg_no) && !window.cb(userUpdateData?.update_photo_reg_no)) {
        errors = { ...errors, update_photo_reg_no: 'Please Enter Reg No *' };
        isError = true;
    } else {
        errors = { ...errors, update_photo_reg_no: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};
export const UserUploadPhotoValidate = (userUpdateData: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(userUpdateData?.photo) && !window.cb(userUpdateData?.photo)) {
        errors = { ...errors, photo: 'Please Upload Photo *' };
        isError = true;
    } else {
        errors = { ...errors, photo: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

// Letter Show Click Validate
export const LetterShowClick = (regNo: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(regNo) && !window.cb(regNo)) {
        errors = { ...errors, regNo: 'Please Enter File No. *' };
        isError = true;
    } else {
        errors = { ...errors, regNo: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

// Letter Show Click Validate
export const LetterShowRegNoClick = (regNo: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(regNo) && !window.cb(regNo)) {
        errors = { ...errors, regNo: 'Please Enter Reg No. *' };
        isError = true;
    } else {
        errors = { ...errors, regNo: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

// Submission Letter validate Form
export const validateSubmissionLetterForm = (data: any) => {
    let isError: boolean = false;
    let errors: any = {};
    let errorObj: any = {};

    // check letters on
    if (!data.collegeChecked && !data.practicalChecked && !data.nocChecked) {
        errors.selectedLettersOn = 'Please select at least one Letters On *';
        isError = true;
    } else {
        errors.selectedLettersOn = '';
    }

    // check Council Name is exist or not
    if (data.nocChecked) {
        if (window.cn(data.council_name)) {
            errors.council_name = 'Council name is required *';
            isError = true;
        } else {
            errors.council_name = '';
        }
    }

    // check Serial Number is exist or not
    if (data.collegeChecked) {
        if (window.cn(data.collegeSerialNo)) {
            errors.collegeSerialNo = 'Serial Number is required *';
            isError = true;
        } else {
            errors.collegeSerialNo = '';
        }
    }

    errorObj = { errors, isError };
    return errorObj;
};

// Wrong Affidavit Letter validate Form
export const validateWrongAffidavitLetterForm = (regNo: any, data: any) => {
    let isError: boolean = false;
    let errors: any = {};
    let errorObj: any = {};

    if (window.cn(regNo) && !window.cb(regNo)) {
        errors = { ...errors, regNo: 'Please Enter File No *' };
        isError = true;
    } else {
        errors = { ...errors, regNo: '' };
    }

    // check Council Is slected or not
    if (!data.CouncilName) {
        if (window.cn(data.CouncilName)) {
            errors.CouncilName = 'Council is required *';
            isError = true;
        } else {
            errors.CouncilName = '';
        }
    }

    errorObj = { errors, isError };
    return errorObj;
};

// False & Fake Letter validate Form
export const validateFalseAndFakeLetterForm = (regNo: any, data: any) => {
    let isError: boolean = false;
    let errors: any = {};
    let errorObj: any = {};

    if (window.cn(regNo) && !window.cb(regNo)) {
        errors = { ...errors, regNo: 'Please Enter File No *' };
        isError = true;
    } else {
        errors = { ...errors, regNo: '' };
    }

    // check Verification Is slected or not
    if (!data.Verification) {
        if (window.cn(data.Verification)) {
            errors.Verification = 'Verification is required *';
            isError = true;
        } else {
            errors.Verification = '';
        }
    }

    // check C-Name Is slected or not
    if (!data.IssuedbyName) {
        if (window.cn(data.IssuedbyName)) {
            errors.IssuedbyName = 'Issued by Name is required *';
            isError = true;
        } else {
            errors.IssuedbyName = '';
        }
    }

    errorObj = { errors, isError };
    return errorObj;
};

//RHUS Letter  add validate
export const RHUSLetterValidate = (RHUSData: any, regNo: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(regNo) && !window.cb(regNo)) {
        errors = { ...errors, regNo: 'Please Enter File No *' };
        isError = true;
    } else {
        errors = { ...errors, regNo: '' };
    }

    if (window.cn(RHUSData?.RollNo) && !window.cb(RHUSData?.RollNo)) {
        errors = { ...errors, RollNo: 'Please Enter Roll No *' };
        isError = true;
    } else {
        errors = { ...errors, RollNo: '' };
    }

    if (window.cn(RHUSData?.DDNo) && !window.cb(RHUSData?.DDNo)) {
        errors = { ...errors, DDNo: 'Please Enter DD No *' };
        isError = true;
    } else {
        errors = { ...errors, DDNo: '' };
    }

    if (window.cn(RHUSData?.amount) && !window.cb(RHUSData?.amount)) {
        errors = { ...errors, amount: 'Please Enter Amount *' };
        isError = true;
    } else {
        errors = { ...errors, amount: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

//University Letter  add validate
export const UniversityLetterValidate = (UniversityData: any, regNo: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(regNo) && !window.cb(regNo)) {
        errors = { ...errors, regNo: 'Please Enter File No *' };
        isError = true;
    } else {
        errors = { ...errors, regNo: '' };
    }

    if (window.cn(UniversityData?.code) && !window.cb(UniversityData?.code)) {
        errors = { ...errors, university: 'Please Select University *' };
        isError = true;
    } else {
        errors = { ...errors, university: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

//Board Letter  add validate
export const BoardLetterValidate = (boardData: any, regNo: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(regNo) && !window.cb(regNo)) {
        errors = { ...errors, regNo: 'Please Enter File No *' };
        isError = true;
    } else {
        errors = { ...errors, regNo: '' };
    }

    if (window.cn(boardData?.board) && !window.cb(boardData?.board)) {
        errors = { ...errors, board: 'Please Select Board *' };
        isError = true;
    } else {
        errors = { ...errors, board: '' };
    }

    if (window.cn(boardData?.ToAddress) && !window.cb(boardData?.ToAddress)) {
        errors = { ...errors, ToAddress: 'Please Enter Address *' };
        isError = true;
    } else {
        errors = { ...errors, ToAddress: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

//School Letter  add validate
export const SchoolLetterValidate = (schoolData: any, regNo: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(regNo) && !window.cb(regNo)) {
        errors = { ...errors, regNo: 'Please Enter File No *' };
        isError = true;
    } else {
        errors = { ...errors, regNo: '' };
    }

    if (window.cn(schoolData?.UniBordCol) && !window.cb(schoolData?.UniBordCol)) {
        errors = { ...errors, UniBordCol: 'Please Enter School Name *' };
        isError = true;
    } else {
        errors = { ...errors, UniBordCol: '' };
    }

    if (window.cn(schoolData?.ToAddress) && !window.cb(schoolData?.ToAddress)) {
        errors = { ...errors, ToAddress: 'Please Enter Address *' };
        isError = true;
    } else {
        errors = { ...errors, ToAddress: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

//RegCancellation Letter  add validate
export const RegCancellationLetterValidate = (regCanData: any, regNo: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(regNo) && !window.cb(regNo)) {
        errors = { ...errors, regNo: 'Please Enter Reg No *' };
        isError = true;
    } else {
        errors = { ...errors, regNo: '' };
    }

    if (window.cn(regCanData?.RefranceLetDate) && !window.cb(regCanData?.RefranceLetDate)) {
        errors = { ...errors, RefranceLetDate: 'Please Select Date *' };
        isError = true;
    } else {
        errors = { ...errors, RefranceLetDate: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

//Reg. Cancellation Letter  add validate
export const AppCancellationLetterValidate = (appCanData: any, regNo: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(regNo) && !window.cb(regNo)) {
        errors = { ...errors, regNo: 'Please Enter Reg No *' };
        isError = true;
    } else {
        errors = { ...errors, regNo: '' };
    }

    if (window.cn(appCanData?.RefranceLetDate) && !window.cb(appCanData?.RefranceLetDate)) {
        errors = { ...errors, RefranceLetDate: 'Please Select Date *' };
        isError = true;
    } else {
        errors = { ...errors, RefranceLetDate: '' };
    }

    if (!appCanData.selectedResponses || appCanData.selectedResponses.length === 0) {
        errors = { ...errors, selectedResponses: 'Please select at least one response *' };
        isError = true;
    } else {
        errors = { ...errors, selectedResponses: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

// Data Flow Letter  add validate
export const DataFlowLetterValidate = (appCanData: any, regNo: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(regNo) && !window.cb(regNo)) {
        errors = { ...errors, regNo: 'Please Enter Reg No *' };
        isError = true;
    } else {
        errors = { ...errors, regNo: '' };
    }

    if (window.cn(appCanData?.letter_date) && !window.cb(appCanData?.letter_date)) {
        errors = { ...errors, letter_date: 'Please Select Date *' };
        isError = true;
    } else {
        errors = { ...errors, letter_date: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

// Warning Letter  add validate
export const WarningLetterValidate = (appCanData: any, regNo: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(regNo) && !window.cb(regNo)) {
        errors = { ...errors, regNo: 'Please Enter Reg No *' };
        isError = true;
    } else {
        errors = { ...errors, regNo: '' };
    }

    // any of one is required
    if (!appCanData.selectedResponses || appCanData.selectedResponses.length === 0) {
        errors = {
            ...errors,
            selectedResponses: 'Please select at least one response.'
        };
        isError = true;
    } else {
        errors = { ...errors, selectedResponses: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

//ReminderToCollege add validate
export const ReminderToCollegeLetterValidate = (collegeData: any, selectedCollege: any, regNo: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(regNo) && !window.cb(regNo)) {
        errors = { ...errors, regNo: 'Please Enter File No *' };
        isError = true;
    } else {
        errors = { ...errors, regNo: '' };
    }

    if (window.cn(selectedCollege?.code) && !window.cb(selectedCollege?.code)) {
        errors = { ...errors, collegeName: 'Please Select College *' };
        isError = true;
    } else {
        errors = { ...errors, collegeName: '' };
    }

    if (window.cn(collegeData?.Reference) && !window.cb(collegeData?.Reference)) {
        errors = { ...errors, Reference: 'Please Enter Reference *' };
        isError = true;
    } else {
        errors = { ...errors, Reference: '' };
    }

    if (window.cn(collegeData?.ToAddress) && !window.cb(collegeData?.ToAddress)) {
        errors = { ...errors, ToAddress: 'Please Enter Address *' };
        isError = true;
    } else {
        errors = { ...errors, ToAddress: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

//ReminderToSchooladd validate
export const ReminderToSchoolLetterValidate = (schoolData: any, regNo: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(regNo) && !window.cb(regNo)) {
        errors = { ...errors, regNo: 'Please Enter File No *' };
        isError = true;
    } else {
        errors = { ...errors, regNo: '' };
    }

    if (window.cn(schoolData?.ReminderName) && !window.cb(schoolData?.ReminderName)) {
        errors = { ...errors, ReminderName: 'Please Enter School Name *' };
        isError = true;
    } else {
        errors = { ...errors, ReminderName: '' };
    }

    if (window.cn(schoolData?.Reference) && !window.cb(schoolData?.Reference)) {
        errors = { ...errors, Reference: 'Please Enter Reference *' };
        isError = true;
    } else {
        errors = { ...errors, Reference: '' };
    }

    if (window.cn(schoolData?.ToAddress) && !window.cb(schoolData?.ToAddress)) {
        errors = { ...errors, ToAddress: 'Please Enter Address *' };
        isError = true;
    } else {
        errors = { ...errors, ToAddress: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

//ReminderToCoucnciladd validate
export const ReminderToCouncilLetterValidate = (schoolData: any, selectedCouncil: any, regNo: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(regNo) && !window.cb(regNo)) {
        errors = { ...errors, regNo: 'Please Enter File No *' };
        isError = true;
    } else {
        errors = { ...errors, regNo: '' };
    }

    if (window.cn(selectedCouncil?.code) && !window.cb(selectedCouncil?.code)) {
        errors = { ...errors, councilName: 'Please Select Council *' };
        isError = true;
    } else {
        errors = { ...errors, councilName: '' };
    }

    if (window.cn(schoolData?.Reference) && !window.cb(schoolData?.Reference)) {
        errors = { ...errors, Reference: 'Please Enter Reference *' };
        isError = true;
    } else {
        errors = { ...errors, Reference: '' };
    }

    if (window.cn(schoolData?.ToAddress) && !window.cb(schoolData?.ToAddress)) {
        errors = { ...errors, ToAddress: 'Please Enter Address *' };
        isError = true;
    } else {
        errors = { ...errors, ToAddress: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

//ReminderToHospital validate
export const ReminderToHospitalLetterValidate = (hospitalData: any, selectedHospital: any, regNo: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(regNo) && !window.cb(regNo)) {
        errors = { ...errors, regNo: 'Please Enter File No *' };
        isError = true;
    } else {
        errors = { ...errors, regNo: '' };
    }

    if (window.cn(selectedHospital?.code) && !window.cb(selectedHospital?.code)) {
        errors = { ...errors, hospitalName: 'Please Select Hospital *' };
        isError = true;
    } else {
        errors = { ...errors, hospitalName: '' };
    }

    if (window.cn(hospitalData?.Reference) && !window.cb(hospitalData?.Reference)) {
        errors = { ...errors, Reference: 'Please Enter Reference *' };
        isError = true;
    } else {
        errors = { ...errors, Reference: '' };
    }

    if (window.cn(hospitalData?.ToAddress) && !window.cb(hospitalData?.ToAddress)) {
        errors = { ...errors, ToAddress: 'Please Enter Address *' };
        isError = true;
    } else {
        errors = { ...errors, ToAddress: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

//ReminderToSchooladd validate
export const ReminderToMedicalLetterValidate = (medicalData: any, regNo: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(regNo) && !window.cb(regNo)) {
        errors = { ...errors, regNo: 'Please Enter File No *' };
        isError = true;
    } else {
        errors = { ...errors, regNo: '' };
    }

    if (window.cn(medicalData?.ReminderName) && !window.cb(medicalData?.ReminderName)) {
        errors = { ...errors, ReminderName: 'Please Enter Medical Name *' };
        isError = true;
    } else {
        errors = { ...errors, ReminderName: '' };
    }

    if (window.cn(medicalData?.Reference) && !window.cb(medicalData?.Reference)) {
        errors = { ...errors, Reference: 'Please Enter Reference *' };
        isError = true;
    } else {
        errors = { ...errors, Reference: '' };
    }

    if (window.cn(medicalData?.ToAddress) && !window.cb(medicalData?.ToAddress)) {
        errors = { ...errors, ToAddress: 'Please Enter Address *' };
        isError = true;
    } else {
        errors = { ...errors, ToAddress: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

//ReminderToUniversity add validate
export const ReminderToUniversityLetterValidate = (unoversityData: any, selectedUniversity: any, regNo: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(regNo) && !window.cb(regNo)) {
        errors = { ...errors, regNo: 'Please Enter File No *' };
        isError = true;
    } else {
        errors = { ...errors, regNo: '' };
    }

    if (window.cn(selectedUniversity?.code) && !window.cb(selectedUniversity?.code)) {
        errors = { ...errors, universityName: 'Please Select University *' };
        isError = true;
    } else {
        errors = { ...errors, universityName: '' };
    }

    if (window.cn(unoversityData?.Reference) && !window.cb(unoversityData?.Reference)) {
        errors = { ...errors, Reference: 'Please Enter Reference *' };
        isError = true;
    } else {
        errors = { ...errors, Reference: '' };
    }

    if (window.cn(unoversityData?.ToAddress) && !window.cb(unoversityData?.ToAddress)) {
        errors = { ...errors, ToAddress: 'Please Enter Address *' };
        isError = true;
    } else {
        errors = { ...errors, ToAddress: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

//ReminderToBoardadd validate
export const ReminderToBoardLetterValidate = (boardData: any, selectedBoard: any, regNo: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(regNo) && !window.cb(regNo)) {
        errors = { ...errors, regNo: 'Please Enter File No *' };
        isError = true;
    } else {
        errors = { ...errors, regNo: '' };
    }

    if (window.cn(selectedBoard?.code) && !window.cb(selectedBoard?.code)) {
        errors = { ...errors, boardName: 'Please Select Board *' };
        isError = true;
    } else {
        errors = { ...errors, boardName: '' };
    }

    if (window.cn(boardData?.Reference) && !window.cb(boardData?.Reference)) {
        errors = { ...errors, Reference: 'Please Enter Reference *' };
        isError = true;
    } else {
        errors = { ...errors, Reference: '' };
    }

    if (window.cn(boardData?.ToAddress) && !window.cb(boardData?.ToAddress)) {
        errors = { ...errors, ToAddress: 'Please Enter Address *' };
        isError = true;
    } else {
        errors = { ...errors, ToAddress: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

//ReminderToNIOS validate
export const ReminderToNIOSLetterValidate = (NIOSData: any, regNo: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(regNo) && !window.cb(regNo)) {
        errors = { ...errors, regNo: 'Please Enter File No *' };
        isError = true;
    } else {
        errors = { ...errors, regNo: '' };
    }

    if (window.cn(NIOSData?.Reference) && !window.cb(NIOSData?.Reference)) {
        errors = { ...errors, Reference: 'Please Enter Reference *' };
        isError = true;
    } else {
        errors = { ...errors, Reference: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};
export const PanaltyUnderJanVishwas = (amount: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(amount) && !window.cb(amount)) {
        errors = { ...errors, amount: 'Please Enter Amount *' };
        isError = true;
    } else if (amount <= 0) {
        errors = { ...errors, amount: 'Please Enter Amount greater than 0 *' };
        isError = true;
    } else {
        errors = { ...errors, amount: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

//ReminderToRHUS validate
export const ReminderToRHUSLetterValidate = (RHUSData: any, regNo: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(regNo) && !window.cb(regNo)) {
        errors = { ...errors, regNo: 'Please Enter File No *' };
        isError = true;
    } else {
        errors = { ...errors, regNo: '' };
    }

    if (window.cn(RHUSData?.Reference) && !window.cb(RHUSData?.Reference)) {
        errors = { ...errors, Reference: 'Please Enter Reference *' };
        isError = true;
    } else {
        errors = { ...errors, Reference: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

//ReminderToCoucnciladd validate
export const NOCLetterValidate = (nocData: any, selectedCouncil: any, regNo: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(regNo) && !window.cb(regNo)) {
        errors = { ...errors, regNo: 'Please Enter File No *' };
        isError = true;
    } else {
        errors = { ...errors, regNo: '' };
    }

    if (window.cn(selectedCouncil?.code) && !window.cb(selectedCouncil?.code)) {
        errors = { ...errors, councilName: 'Please Select Council *' };
        isError = true;
    } else {
        errors = { ...errors, councilName: '' };
    }

    if (window.cn(nocData?.Reference) && !window.cb(nocData?.Reference)) {
        errors = { ...errors, Reference: 'Please Enter Reference *' };
        isError = true;
    } else {
        errors = { ...errors, Reference: '' };
    }

    if (window.cn(nocData?.ToAddress) && !window.cb(nocData?.ToAddress)) {
        errors = { ...errors, ToAddress: 'Please Enter Address *' };
        isError = true;
    } else {
        errors = { ...errors, ToAddress: '' };
    }

    if (window.cn(nocData?.BOD) && !window.cb(nocData?.BOD)) {
        errors = { ...errors, BOD: 'Please Enter Date of Birth *' };
        isError = true;
    } else {
        errors = { ...errors, BOD: '' };
    }
    if (window.cn(nocData?.DegNm) && !window.cb(nocData?.DegNm)) {
        errors = { ...errors, DegNm: 'Please Enter Degree *' };
        isError = true;
    } else {
        errors = { ...errors, DegNm: '' };
    }
    if (window.cn(nocData?.RegDate) && !window.cb(nocData?.RegDate)) {
        errors = { ...errors, RegDate: 'Please Enter Reg Date *' };
        isError = true;
    } else {
        errors = { ...errors, RegDate: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

//TransferIn validate
export const TransferInLetterValidate = (transferInData: any, selectedCouncil: any, regNo: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(regNo) && !window.cb(regNo)) {
        errors = { ...errors, regNo: 'Please Enter File No *' };
        isError = true;
    } else {
        errors = { ...errors, regNo: '' };
    }

    if (window.cn(selectedCouncil?.code) && !window.cb(selectedCouncil?.code)) {
        errors = { ...errors, councilName: 'Please Select Council *' };
        isError = true;
    } else {
        errors = { ...errors, councilName: '' };
    }

    if (window.cn(transferInData?.RegNo) && !window.cb(transferInData?.RegNo)) {
        errors = { ...errors, RegNo: 'Please Enter Reg No *' };
        isError = true;
    } else {
        errors = { ...errors, RegNo: '' };
    }

    if (window.cn(transferInData?.Address) && !window.cb(transferInData?.Address)) {
        errors = { ...errors, Address: 'Please Enter Address *' };
        isError = true;
    } else {
        errors = { ...errors, Address: '' };
    }

    if (window.cn(transferInData?.UserCity) && !window.cb(transferInData?.UserCity)) {
        errors = { ...errors, UserCity: 'Please Enter City *' };
        isError = true;
    } else {
        errors = { ...errors, UserCity: '' };
    }
    if (window.cn(transferInData?.DDNoWithDate) && !window.cb(transferInData?.DDNoWithDate)) {
        errors = { ...errors, DDNoWithDate: 'Please Enter DD No With Date *' };
        isError = true;
    } else {
        errors = { ...errors, DDNoWithDate: '' };
    }
    if (window.cn(transferInData?.RegDate) && !window.cb(transferInData?.RegDate)) {
        errors = { ...errors, RegDate: 'Please Enter Reg Date *' };
        isError = true;
    } else {
        errors = { ...errors, RegDate: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

//TransferIn validate
export const PracticalTrainingValidate = (transferInData: any, selectedhospital: any, regNo: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(regNo) && !window.cb(regNo)) {
        errors = { ...errors, regNo: 'Please Enter File No *' };
        isError = true;
    } else {
        errors = { ...errors, regNo: '' };
    }

    if (window.cn(selectedhospital?.code) && !window.cb(selectedhospital?.code)) {
        errors = { ...errors, hospitalName: 'Please Select Hospital *' };
        isError = true;
    } else {
        errors = { ...errors, hospitalName: '' };
    }

    if (window.cn(transferInData?.year) && !window.cb(transferInData?.year)) {
        errors = { ...errors, year: 'Please Enter Year *' };
        isError = true;
    } else {
        errors = { ...errors, year: '' };
    }

    if (window.cn(transferInData?.address) && !window.cb(transferInData?.address)) {
        errors = { ...errors, address: 'Please Enter Address *' };
        isError = true;
    } else {
        errors = { ...errors, address: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

// Letter Show Click Validate
export const ReportShowClick = (application: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(application?.code) && !window.cb(application?.code)) {
        errors = { ...errors, application: 'Please Select Application *' };
        isError = true;
    } else {
        errors = { ...errors, application: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};
// Record Register Validate
export const RecordRegisterValidate = (selectedRegPrefix: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(selectedRegPrefix?.code) && !window.cb(selectedRegPrefix?.code)) {
        errors = { ...errors, application: 'Please Select Option *' };
        isError = true;
    } else {
        errors = { ...errors, application: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};
// CollegeWiseRegister Validate
export const CollegeWiseRegisterReportValidate = (college: any, degree: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(college?.code) && !window.cb(college?.code)) {
        errors = { ...errors, college: 'Please Select College *' };
        isError = true;
    } else {
        errors = { ...errors, college: '' };
    }

    if (window.cn(degree?.code) && !window.cb(degree?.code)) {
        errors = { ...errors, degree: 'Please Select Degree *' };
        isError = true;
    } else {
        errors = { ...errors, degree: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};
// PCIRegister Validate
export const PCIRegisterReportValidate = (regDetails: any, regPrefix: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(regDetails?.year) && !window.cb(regDetails?.year)) {
        errors = { ...errors, year: 'Please Enter year *' };
        isError = true;
    } else {
        errors = { ...errors, year: '' };
    }

    if (window.cn(regPrefix?.code) && !window.cb(regPrefix?.code)) {
        errors = { ...errors, application: 'Please Select Option *' };
        isError = true;
    } else {
        errors = { ...errors, application: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};
// GonoValidate
export const GNoValidation = (regNo: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(regNo) && !window.cb(regNo)) {
        errors = { ...errors, RegNo: 'Please Enter Reg No. *' };
        isError = true;
    } else {
        errors = { ...errors, RegNo: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

// Application Detail validstion
export const ApplicationDetailValidation = (regDetails: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(regDetails?.reg_no) && !window.cb(regDetails?.reg_no)) {
        errors = { ...errors, reg_no: 'Please Enter Reg No. *' };
        isError = true;
    } else {
        errors = { ...errors, reg_no: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

// PermanentFileCloseValidation Validate
export const PermanentFileCloseValidation = (reason: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(reason) && !window.cb(reason)) {
        errors = { ...errors, reason: 'Please Enter Reason *' };
        isError = true;
    } else {
        errors = { ...errors, reason: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

//Verification Date Validation
export const VerificationDateValidation = (VerificationDate: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(VerificationDate) && !window.cb(VerificationDate)) {
        errors = { ...errors, VerificationDate: 'Select Verification Date *' };
        isError = true;
    } else {
        errors = { ...errors, VerificationDate: '' };
    }

    errorObj = { errors, isError };

    return errorObj;
};

// Add update college validate
export const addUpdateNoticeValidate = (noticeDetails: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(noticeDetails.notice_title) && !window.cb(noticeDetails.notice_title)) {
        errors = { ...errors, notice_title: 'Please Enter Title *' };
        isError = true;
    } else {
        errors = { ...errors, notice_title: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

// Add update college validate
export const addUpdateGallry = (noticeDetails: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(noticeDetails.image) && !window.cb(noticeDetails.image)) {
        errors = { ...errors, image: 'Please Upload Image *' };
        isError = true;
    } else {
        errors = { ...errors, image: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

// Add update college validate
export const addGallryValidate = (gallaryImages: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (gallaryImages.length === 0) {
        errors = { ...errors, gallary_image: 'Please Upload Image *' };
        isError = true;
    } else {
        errors = { ...errors, gallary_image: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

//Verification Validation
export const VerificationValidation = (inputDetails: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(inputDetails?.verificationNote) && !window.cb(inputDetails?.verificationNote)) {
        errors = { ...errors, verificationNote: 'Enter Verification Note *' };
        isError = true;
    } else {
        errors = { ...errors, verificationNote: '' };
    }
    errorObj = { errors, isError };

    return errorObj;
};

//Verification Validation
export const addDocumentMasterValidate = (documentName: any) => {
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(documentName) && !window.cb(documentName)) {
        errors = { ...errors, documentName: 'Enter Document Name *' };
        isError = true;
    } else {
        errors = { ...errors, documentName: '' };
    }
    errorObj = { errors, isError };

    return errorObj;
};
